import FractionDigits from '@/Enums/Localization/FractionDigits.enum';
import { numberToPercent } from '@/helpers/valueFormatter/numberFormatter.helpers';
import { TooltipItem } from 'chart.js';

interface ITooltipFooterOptions {
  fractionDigits?: number;
}

export const tooltipFooterCb =
  (options: ITooltipFooterOptions) =>
  <TType extends 'doughnut' | 'pie'>(contexts: TooltipItem<TType>[]): string => {
    try {
      if (!contexts.length) {
        return '';
      }
      const [{ dataset, raw }] = contexts;
      // @ts-expect-error faulty types
      const sum = (dataset.data ?? []).reduce((acc, value) => acc + value, 0);
      if (!sum) {
        return '0%';
      }
      return numberToPercent((raw as number) / sum, {
        maximumFractionDigits: options?.fractionDigits ?? FractionDigits.Extended,
      });
    } catch {
      return '';
    }
  };
